/** @jsx jsx */
import { memo } from 'react';
import { css, jsx } from '@emotion/react';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { getBackground } from './utils';
import { commonSVGStyles, sizeStyleMap } from './styles';

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var svgStyles = css(commonSVGStyles);

/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */
var SVG = /*#__PURE__*/memo(function SVG(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    label = _ref.label,
    _ref$primaryColor = _ref.primaryColor,
    primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor,
    secondaryColor = _ref.secondaryColor,
    testId = _ref.testId,
    children = _ref.children;
  var _useGlobalTheme = useGlobalTheme(),
    mode = _useGlobalTheme.mode;
  return jsx("svg", {
    viewBox: "0 0 24 24",
    style: {
      color: primaryColor,
      fill: secondaryColor || getBackground(mode)
    },
    css: [svgStyles, sizeStyleMap[size]],
    "data-testid": testId,
    "aria-label": label || undefined,
    role: label ? 'img' : 'presentation'
  }, children);
});
export default SVG;